import React from 'react';
import Category from 'components/products/Category';
import { getProductCategory } from 'data/categories';
import { isAddAtlasToPurchaseFFOn, isJPDInCatalogFFOn } from 'util/featureFlags';
import { useSelector } from 'react-redux';

export default () => {
  const isAddAtlasToPurchaseOn = useSelector(isAddAtlasToPurchaseFFOn).result;
  const isJPDInCatalogOn = useSelector(isJPDInCatalogFFOn).result;
  const cartProductCategory = getProductCategory(isAddAtlasToPurchaseOn, isJPDInCatalogOn);

  return cartProductCategory.map((category) => (
    <Category key={category.name} name={category.name} products={category.products} />
  ));
};
